import {Component, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {DatePipe} from '@angular/common';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {ResidentForSelect, DailyReport} from '../../../types/data.types';
import {DailyReportsService} from '../../../services/daily-reports.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'daily-reports-add-entry-modal',
    templateUrl: './daily-reports-add-entry-modal.component.html',
    styleUrls: ['./daily-reports-add-entry-modal.component.scss']
})
export class DailyReportsAddEntryModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    suites: Array<any> = [];
    residents: Array<ResidentForSelect> = [];
    data: DailyReport = new DailyReport();
    disabledSubmit = false;
    date: string = (new Date).toISOString();
    time = DailyReportsAddEntryModalComponent.parseTime((new Date()).toISOString());

    static parseTime(dateString: string): string {
        return (new DatePipe('en-US')).transform(dateString, 'hh:mm a');
    }

    constructor(
        public api: ApiClientService,
        public dailyReportsService: DailyReportsService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        this.initTimePicker();
        setTimeout( () => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    initTimePicker() {
        $('#timepicker1').timepicker().on('changeTime.timepicker', e => this.time = e.time.value);
    }

    openTimepicker(): void {
        $('#timepicker1').timepicker('showWidget');
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.dailyReportsService.addEntryModal = false;
                    this.dailyReportsService.dailyReportInDailyReportsModal = null;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.dailyReportsService.addEntryModal = false;
            this.dailyReportsService.dailyReportInDailyReportsModal = null;
            this.urlService.modalClosed.emit();
        }
    }

    onSubmit(form: NgForm) {
        if (!form.valid) {
            if (!form.value.date)       toastr.warning('Date To should not be blank.');
            if (!form.value.details)       toastr.warning('Details should not be blank.');
            return;
        }

        const data: any = {
            dailyReport:     this.dailyReportsService.dailyReportInDailyReportsModal.id,
            dateTo:          this.getDateTimeFromForm(),
            details:          form.value.details
        };

        this.disabledSubmit = true;

        this.api.post('domainDailyReports', '/v1/daily_report_entry.json', data).subscribe(
            () => this.updateView('Daily Report entry successfully created'),
            error => {
                this.disabledSubmit = false;
                this.api.errorHandler(error, 'Create Daily Report entry failed');
            }
        );
    }

    getDateTimeFromForm(): Date {
        const date = new Date(this.form.value.date);
        const time = this.form.value.time;
        const timeObj = new Date(`01/01/1970 ${time}`);
        const hours   = timeObj.getHours();
        const minutes = timeObj.getMinutes();
        date.setHours(hours);
        date.setMinutes(minutes);
        return date;
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.dailyReportsService.getData();
        this.form.reset();
        this.hideModal();
    }

}



// WEBPACK FOOTER //
// /app/src/app/views/daily-reports/daily-reports-add-entry-modal/daily-reports-add-entry-modal.component.ts